import { render, staticRenderFns } from "./ServiceColorLegend.vue?vue&type=template&id=b4093bb6&scoped=true&"
import script from "./ServiceColorLegend.vue?vue&type=script&lang=js&"
export * from "./ServiceColorLegend.vue?vue&type=script&lang=js&"
import style0 from "./ServiceColorLegend.vue?vue&type=style&index=0&id=b4093bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4093bb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
